module.exports = __webpack_public_path__ + "img/icon_link_off.728bcb66.svg";